/* eslint-disable no-sparse-arrays */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import Header from "./../components/Header";
import Footer from "./../components/Footer";
import securites from "./../assets/img/brokerlogoclient/ACY Securities logo.jpg";
import admiralmarket from "./../assets/img/brokerlogoclient/Admirals Markets logo.png";
import avatrade from "./../assets/img/brokerlogoclient/AvaTrade logo.jpg";
import axi from "./../assets/img/brokerlogoclient/Axi logo.png";
import blackbull from "./../assets/img/brokerlogoclient/Blackbull logo.png";
import captial from "./../assets/img/brokerlogoclient/Capital.com logo2.png";
import cityindex from "./../assets/img/brokerlogoclient/City Index logo.png";
import Eightcap from "./../assets/img/brokerlogoclient/EightCap logo.png";
import etoro from "./../assets/img/brokerlogoclient/eToro logo.png";
import forexcom from "./../assets/img/brokerlogoclient/forex.com logo.png";
import fpmarket from "./../assets/img/brokerlogoclient/FP Markets logo.png";
import fusionmarket from "./../assets/img/brokerlogoclient/Fusion Markets logo.jpg";
import fxcmlogo from "./../assets/img/brokerlogoclient/FXCM logo.png";
import fxpro from "./../assets/img/brokerlogoclient/Fxpro logo.svg";
import fxtm from "./../assets/img/brokerlogoclient/FXTM logo2.png";
import globalprime from "./../assets/img/brokerlogoclient/Global Prime Logo.png";
import gomarket from "./../assets/img/brokerlogoclient/Go Markets logo.jpeg";
import HFmarket from "./../assets/img/brokerlogoclient/HF Markets.png";
import Hycmlogo from "./../assets/img/brokerlogoclient/HYCM logo.png";
import ICmarket from "./../assets/img/brokerlogoclient/IC Markets logo2.png";
import IG from "./../assets/img/brokerlogoclient/IG Logo.jpg";
import marketcom from "./../assets/img/brokerlogoclient/Markets.com logo.jpeg";
import monetamarket from "./../assets/img/brokerlogoclient/Moneta Markets logo2.png";
import multibank from "./../assets/img/brokerlogoclient/MultiBank logo.svg";
import oandalogo from "./../assets/img/brokerlogoclient/Oanda Logo.jpg";
import peperstone from "./../assets/img/brokerlogoclient/Pepperstone logo.png";
import swisslogo from "./../assets/img/brokerlogoclient/Swissquote logo.png";
import tickmil from "./../assets/img/brokerlogoclient/Tickmill logo.png";
import tmgm from "./../assets/img/brokerlogoclient/TMGM logo.jpeg";
import tradenation from "./../assets/img/brokerlogoclient/Trade Nation logo.png";
import vintage from "./../assets/img/brokerlogoclient/Vantage logo.png";
import xtm from "./../assets/img/brokerlogoclient/XM logo.jpg";
import activetrade from "./../assets/img/main-icon.jpg";
import plus500 from "./../assets/img/brokerlogoclient/Plus500 logo2.png";
import XTB from "./../assets/img/Xtb-logo.png";
import Select from 'react-select'
import CMCmarketlogo from "./../assets/img/brokerlogoclient/CMC Markets Logo.png";
import { useState } from "react";
import { Link, } from "react-router-dom";
import { LuExternalLink } from "react-icons/lu";

const Allreview = () => {
  const countries = [
    { value: 'AllCountry', label: 'All Country' },
    { value: 'Afghanistan', label: 'Afghanistan' },
    { value: 'Albania', label: 'Albania' },
    { value: 'Algeria', label: 'Algeria' },
    { value: 'American Samoa', label: 'American Samoa' },
    { value: 'Andorra', label: 'Andorra' },
    { value: 'Angola', label: 'Angola' },
    { value: 'Anguilla', label: 'Anguilla' },
    { value: 'Antigua & Barbuda', label: 'Antigua & Barbuda' },
    { value: 'Argentina', label: 'Argentina' },
    { value: 'Armenia', label: 'Armenia' },
    { value: 'Aruba', label: 'Aruba' },
    { value: 'Australia', label: 'Australia' },
    { value: 'Austria', label: 'Austria' },
    { value: 'Bahrain', label: 'Bahrain' },
    { value: 'Bangladesh', label: 'Bangladesh' },
    { value: 'Belgium', label: 'Belgium' },
    { value: 'Brazil', label: 'Brazil' },
    { value: 'China', label: 'China' },
    { value: 'Cyprus', label: 'Cyprus' },
    { value: 'Denmark', label: 'Denmark' },
    { value: 'Egypt', label: 'Egypt' },
    { value: 'Finland', label: 'Finland' },
    { value: 'France', label: 'France' },
    { value: 'Germany', label: 'Germany' },
    { value: 'Hong Kong', label: 'Hong Kong' },
    { value: 'Ireland', label: 'Ireland' },
    { value: 'Israel', label: 'Israel' },
    { value: 'Italy', label: 'Italy' },
    { value: 'Japan', label: 'Japan' },
    { value: 'Kuwait', label: 'Kuwait' },
    { value: 'Luxembourg', label: 'Luxembourg' },
    { value: 'Netherlands', label: 'Netherlands' },
    { value: 'New Zealand', label: 'New Zealand' },
    { value: 'Oman', label: 'Oman' },
    { value: 'Poland', label: 'Poland' },
    { value: 'Qatar', label: 'Qatar' },
    { value: 'Saudi Arabia', label: 'Saudi Arabia' },
    { value: 'Singapore', label: 'Singapore' },
    { value: 'South Africa', label: 'South Africa' },
    { value: 'Spain', label: 'Spain' },
    { value: 'Sweden', label: 'Sweden' },
    { value: 'Switzerland', label: 'Switzerland' },
    { value: 'United Arab Emirates', label: 'United Arab Emirates' },
    { value: 'United Kingdom', label: 'United Kingdom' }
  ];
  const BrokerData = [
    {
      Name: "Plus500",
      Country: [
        "AllCountry",
        "Australia",
        "Argentina",
        "Austria",
        "Andorra",
        'Hong Kong',
        "Bahrain",
        "Cyprus",
        "Denmark",
        "Germany",
        "Ireland",
        "Finland",
        "Israel",
        "Japan",
        "Italy",
        "Kuwait",
        "Luxembourg",
        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],

      url: "https://www.plus500.com",
      ratting: 4.9,
      lose: '82',
      path: "/reviewdetail",
      mindeposit: "$100",
      maxLeverge: "30:1",
      platform: "Plus500 App,Webtrader",
      brokerimg: plus500,
      Recommended: true,
    },
    {
      Name: "XTB",
      lose: '76',
      Country: ['AllCountry',
        'Afghanistan', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Austria', 'Bahrain', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      url: "https://www.xtb.com",
      path: "/xtb-review",
      ratting: 4.9,
      mindeposit: "$0",
      maxLeverge: "30:1",
      platform: "xStation 5, MT4",
      brokerimg: XTB,
      Recommended: true,
    },
    {
      Name: "ActivTrades",
      Country: ['AllCountry', "Egypt", "American Samoa", "Kuwait", "Bangladesh", "Behrain", "Oman", "Qatar", "Israel", "Algeria", "Israel", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.activtrades.com",
      lose: '81',
      ratting: 4.9,
      mindeposit: "$0",
      path: "/activtraders-review",
      maxLeverge: "200:1",
      platform: "Activtrader, MT4, MT5, TradingView",
      brokerimg: activetrade,
      Recommended: true,
    },



    {
      Name: "IG",
      lose: '71',
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],

      url: "https://www.ig.com",
      path: "/ig-review",
      ratting: 4.8,
      mindeposit: "$50",
      maxLeverge: "50:1",
      platform: "MT4, IG App",
      brokerimg: IG,
      Recommended: false,
    },
    {
      Name: "Pepperstone",
      url: "https://pepperstone.com",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Ireland', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],

      lose: '74-89',
      ratting: 4.8,
      mindeposit: "$0",
      path: "/pepperstone-review-2",
      maxLeverge: "30:1",
      platform: "MT4, MT5, Trader, TradingView",
      brokerimg: peperstone,
      Recommended: false,
    },
    {
      Name: "FOREX.com",
      url: "https://www.forex.com",
      Country: ['AllCountry', "Israeal ", "American Samoa", "Behrain", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '75',
      ratting: 4.8,
      path: "/forex-com-review",
      mindeposit: "$100",
      maxLeverge: "400:1",
      platform: "Forex.com App, Webtrader, MT4, MT5, TradingView",
      brokerimg: forexcom,
      Recommended: false,
    },
    {
      Name: "Fxpro",
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.fxpro.com",
      lose: '81.85',
      path: "/fxpro-review",
      ratting: 4.7,
      mindeposit: "$100",
      maxLeverge: "200:1",
      platform: "FxPro App, MT4, MT5, cTrader",
      brokerimg: fxpro,
      Recommended: false,
    },
    {
      Name: "City Index",
      Country: ['AllCountry', "Australia", "United Arab Emirates", "United Kingdom"],

      lose: '70',
      path: "/city-index-review",
      url: "https://www.cityindex.com",
      ratting: 4.7,
      mindeposit: "$150",
      maxLeverge: "30:1",
      platform: "City Index App, Webtrader, MT4, TradingView ",
      brokerimg: cityindex,
      Recommended: false,
    },
    {
      Name: "CMC Markets",
      lose: '69',
      Country: ['AllCountry', "Luxembourg", "Albania", "Israeal", "Algeria", "Italy", 'Hong Kong', "Australia", "Austria", "Bahrain", "Belgium", "Cyprus", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "United Arab Emirates", "United Kingdom"],
      url: "https://www.cmcmarkets.com",
      path: "/cmc-markets-review",

      ratting: 4.7,
      mindeposit: "$0",
      maxLeverge: "30:1",
      platform: "CMC App, MT4",
      brokerimg: CMCmarketlogo,
      Recommended: false,
    },
    {
      Name: "Tickmill",
      lose: '72',


      Country: ['AllCountry', "Israel", , "Algeria", "Israeal", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.tickmill.com",

      ratting: 4.7,
      mindeposit: "$100",
      maxLeverge: "30:1",
      platform: "MT4, MT5, Tickmill App",
      brokerimg: tickmil,
      Recommended: false,
    },
    {
      lose: '74-89',
      Name: "Oanda",
      url: "https://www.oanda.com",
      Country: ['AllCountry', "Algeria", "Israel", , "Andorra", "American Samoa", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      ratting: 4.7,
      mindeposit: "$0",
      maxLeverge: "888:1",
      platform: "MT4, MT5, FXTrade App",
      brokerimg: oandalogo,
      Recommended: false,
    },
    {
      Name: "Admirals Markets",
      lose: '80',
      Country: ['AllCountry',
        'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]

      ,
      url: "https://admiralmarkets.com",

      ratting: 4.7,
      mindeposit: "$100",
      maxLeverge: "1000:1",
      platform: "MT4, MT5, Admirals App",
      brokerimg: admiralmarket,
      Recommended: false,
    },
    {
      Name: "eToro",
      Country: ['AllCountry',
        "Australia", "Austria", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland",
        "France", "Germany", "Ireland", "Italy", "Luxembourg", "Netherlands",
        "Norway", "Oman", "Poland", "Qatar", "Singapore", "South Africa",
        "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"
      ],

      url: "https://www.etoro.com",
      lose: '74-89',
      ratting: 4.7,
      mindeposit: "$10",
      maxLeverge: "30:1",
      platform: "eToro App",
      brokerimg: etoro,
      Recommended: false,
    },
    {
      Name: "Fusion Markets",
      lose: '74-89',
      Country: ['AllCountry', "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://fusionmarkets.com",
      ratting: 4.6,
      mindeposit: "$0",
      maxLeverge: "500:1",
      platform: "MT4, MT5, cTrader",
      brokerimg: fusionmarket,
      Recommended: false,
    },
    {
      Name: "Capital.com",
      lose: '79  ',

      Country: ['AllCountry', "Angola", "Algeria", "Albania", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.capital.com",
      ratting: 4.7,
      mindeposit: "$20",
      maxLeverge: "30:1",
      platform: "Capital.com App, Webtrader, MT4, TradingView",
      brokerimg: captial,
      Recommended: false,
    },
    {
      Name: "Swissquote",
      lose: '77',
      Country: ['AllCountry',
        "Andorra", "Austria", "Albania", "Australia", "Brazil", "Armenia", "Israeal", "China", "Bahrain", "Argentina", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Egypt",
        "Denmark", "Estonia", "Finland", "France", "Germany", "Gibraltar", "Greece", "Guernsey", "Hungary",
        "Iceland", "Ireland", "Isle of Man", "Italy", "Jersey", "Kuwait", "Latvia", "Liechtenstein",
        "Lithuania", "Luxembourg", "Malta", "Monaco", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal",
        "Qatar", "Romania", "San Marino", "Saudi Arabia", "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland",
        "United Arab Emirates", "United Kingdom"
      ],
      url: "https://en.swissquote.com",
      ratting: 4.6,
      mindeposit: "$1000",
      maxLeverge: "100:1",
      platform: "Swissquote App, MT4, MT5",
      brokerimg: swisslogo,
      Recommended: false,
    },
    {
      Name: "IC Markets",
      lose: '72-32',
      Country: ['AllCountry', "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.icmarkets.com",
      ratting: 4.6,
      mindeposit: "$200",
      maxLeverge: "500:1",
      platform: "MT4, MT5, cTrader",
      brokerimg: ICmarket,
      Recommended: false,
    },

    {
      Name: "XM",
      Country: ['AllCountry', "Algeria", "Andorra", "Angola", "Antigua & Barbuda", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '74-89',
      url: "https://www.xm.com",
      ratting: 4.6,
      mindeposit: "$5",
      maxLeverge: "1000:1",
      platform: "MT4, MT5, XM App",
      brokerimg: xtm,
      Recommended: false,
    },
    {
      Name: "FXCM",

      Country: ['AllCountry', "Algeria", "Albania", "Andorra", "Denmark", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Egypt", "Finland", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '71',
      ratting: 4.6,
      url: "https://www.fxcm.com",
      mindeposit: "$50",
      maxLeverge: "1000:1",
      platform: "FXCM App, Webtrader, TradingView, MT4",
      brokerimg: fxcmlogo,
      Recommended: false,
    },
    {
      Name: "ACY Securities",
      lose: '74-89',
      Country: ['AllCountry', "United Arab Emirates", "United Kingdom"],
      url: "https://acy.com",
      ratting: 4.6,
      mindeposit: "$50",
      maxLeverge: "500:1",
      platform: "MT4, MT5",
      brokerimg: securites,
      Recommended: false,
    },
    {
      Name: "Global Prime",
      lose: '74-89',


      Country: ['AllCountry', "Qatar", "Hong Kong", "Bangladesh", "Austria", "Denmark", "Behrain", "Belgium", "Cyprus", "Kuwait", "Netherlands", "Ireland", "Israel", "Egypt", "American Samoa", "Aruba", "Armenia", "Antigua & Barbuda", "Angola", "Argentina", "Algeria", "Andorra", "Anguilla", "Poland", "Luxembourg", "Switzerland", "Italy", "Spain", "Israel", "Albania", "Saudi Arabia", "Finland", "United States", "China", "India", "Brazil", "United Kingdom", "Germany", "France", "Australia", "Canada", "Japan", "Sweden", "Sweden"],

      url: "https://www.globalprime.com",
      ratting: 4.6,
      mindeposit: "$10",
      maxLeverge: "200:1",
      platform: "MT4",
      brokerimg: globalprime,
      Recommended: false,
    },
    {
      lose: '76',
      Name: "Avatrade",
      Country: ['AllCountry', "American Samoa", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Japan", "Kuwait", "Luxembourg", "Netherlands", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.avatrade.com",
      ratting: 4.6,
      mindeposit: "$100",
      maxLeverge: "400:1",
      platform: "AvaTrade App, Webtrader, MT4, MT5",
      brokerimg: avatrade,
      Recommended: false,
    },
    {
      Name: "FP Markets",
      lose: '74-89',
      Country: ['AllCountry', "Qatar", "Behrain", "Egypt", "Kuwait", "Israel", "Algeria", "Oman", "Albania", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Finland", "France", "Germany", "Greece", "Hong Kong", "Hungary", "Iceland", "Ireland", "Italy", "Luxembourg", "Malta", "Monaco", "Netherlands", "Norway", "Poland", "Portugal", "Romania", "San Marino", "Saudi Arabia", "Singapore", "Slovakia", "Slovenia", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.fpmarkets.com",
      ratting: 4.6,
      mindeposit: "$50",
      maxLeverge: "500:1",
      platform: "MT4, MT5, cTrader",
      brokerimg: fpmarket,
      Recommended: false,
    },
    {
      Name: "MultiBank",
      Country: ['AllCountry', "American Samoa", "Israel", "Albania", "Afghanistan", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Belgium", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '74-89',
      url: "https://multibankfx.com",
      ratting: 4.5,
      mindeposit: "$50",
      maxLeverge: "500:1",
      platform: "MultiBank Trader4/5, MT4, MT5",
      brokerimg: multibank,
      Recommended: false,
    },
    {
      Name: "Eightcap",
      lose: '77.78',
      Country: ['AllCountry', "Angola", "Aruba", "Bangladesh", "Oman", "Egypt", "American Samoa", "Behrain", "China", "Kuwait", "Armenia", "Algeria", "Argentina", "Saudi Arabia", "Italy", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Australia", "Austria", "Belgium", "Brazil", "Denmark", "Finland", "France", "Germany", "Hong Kong", "Ireland", "Luxembourg", "Netherlands", "New Zealand", "Poland", "Singapore", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      url: "https://www.eightcap.com",
      ratting: 4.5,
      mindeposit: "$100",
      maxLeverge: "500:1",
      platform: "MT4, MT5, TradingView, Webtrader",
      brokerimg: Eightcap,
      Recommended: false,
    },
    {
      Name: "Vantage",
      lose: '74-89',
      Country: ['AllCountry', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,

      url: "https://www.vantagemarkets.com",
      ratting: 4.5,
      mindeposit: "$50",
      maxLeverge: "500:1",
      platform: "Vantage App, Webtrader, TradingView, MT4, MT5",
      brokerimg: vintage,
      Recommended: false,
    },
    {
      Name: "HYCM",
      Country: ['AllCountry', "Israel", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Cyprus", "Denmark", "Egypt", "Finland", "Germany", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '74-89',
      url: "https://hycm.com",
      ratting: 4.5,
      mindeposit: "$100",
      maxLeverge: "500:1",
      platform: "MT4, MT5, HYCM Trader",
      brokerimg: Hycmlogo,
      Recommended: false,
    },
    {
      Name: "HF Markets",
      url: "https://www.hfm.com",
      ratting: 4.5,
      Country: ['AllCountry', "United Arab Emirates"
        , "United Kingdom"],
      lose: '74.14',
      mindeposit: "$5",
      maxLeverge: "2000:1",
      platform: "HFM Platform, MT4, MT5",
      brokerimg: HFmarket,
      Recommended: false,
    },
    {
      Name: "Moneta Markets",
      lose: '74-89',
      Country: ['AllCountry', "Andorra", "Algeria", "Angola", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Denmark", "Egypt", "Finland", "Germany", "Hong Kong", "Ireland", "Israel", "Italy", "Kuwait", "Luxembourg", "Netherlands", "New Zealand", "Oman", "Poland", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates"],

      url: "	https://www.monetamarkets.com",
      ratting: 4.5,
      mindeposit: "$50",
      maxLeverge: "1000:1",
      platform: "Moneta Markets App, ProTrader, MT4,MT5",
      brokerimg: monetamarket,
      Recommended: false,
    },
    {
      Name: "Go Markets",
      lose: '74-89',
      Country: ['AllCountry', "Bangladesh", "Luxembourg", "Bangladesh", "Oman", "Egypt", "Brazil", "Cyprus", "Ireland", "Denmark", "Austria", "Netherlands", "Behrain", "Hong Kong", "Armenia", "Angola", "Aruba", "Antigua & Barbuda", "Albania", "Andorra", "Argentina", "Algeria", "Poland", "Sweden", "Japan", "Italy", "Australia", "France", "Finland", "Germany", "United Kingdom", "Kuwait", "South Africa", "Saudi Arabia", "United Arab Emirates", "New Zealand"]
      ,
      url: "https://www.gomarkets.com",
      ratting: 4.4,
      mindeposit: "$200",
      maxLeverge: "500:1",
      platform: "cTrader, MT4, MT5",
      brokerimg: gomarket,
      Recommended: false,
    },
    {
      Name: "Markets.com",
      url: "https://www.markets.com",
      Country: ['AllCountry', "Saudi Arabia", "Egypt", "Albania", "Andorra", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Cyprus", "Denmark", "Egypt", "Finland", "France", "Germany", "Iceland", "Ireland", "Italy", "Kuwait", "Luxembourg", "Netherlands", "Norway", "Oman", "Poland", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Spain", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],

      lose: '67.7',
      ratting: 4.4,
      mindeposit: "$100",
      maxLeverge: "300:1",
      platform: "Markets.com App, Webtrader, MT4, MT5",
      brokerimg: marketcom,
      Recommended: false,
    },
    {
      Name: "FXTM",
      lose: '81',
      Country: ['AllCountry', "Afghanistan", "Israel", "Algeria", "Albania", "Andorra", "Angola", "Anguilla", "Antigua & Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Bahrain", "Bangladesh", "Brazil", "China", "Egypt", "Iceland", "Kuwait", "New Zealand", "Norway", "Oman", "Portugal", "Qatar", "Saudi Arabia", "Singapore", "South Africa", "Sweden", "Switzerland", "United Arab Emirates", "United Kingdom"],
      url: "https://www.forextime.com",
      ratting: 4.4,
      mindeposit: "$10",
      maxLeverge: "2000:1",
      platform: "FXTM App, MT4, MT5",
      brokerimg: fxtm,
      Recommended: false,
    },
    {
      Name: "Trade Nation",

      Country: ['AllCountry', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ]
      ,

      lose: '74-89',
      url: "https://tradenation.com",
      ratting: 4.4,
      mindeposit: "$0",
      maxLeverge: "200:1",
      platform: "Trade Nation App, MT4",
      brokerimg: tradenation,
      Recommended: false,
    },
    {
      Name: "BlackBull",
      Country: ['AllCountry',
        'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China', 'Cyprus',
        'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Kuwait',
        'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Saudi Arabia', 'Singapore', 'South Africa',
        'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      lose: '74-89',
      url: "https://blackbull.com",
      ratting: 4.4,
      mindeposit: "$10",
      maxLeverge: "500:1",
      platform: "MT4, MT5, TradingView, Blackbull Trade, cTrader",
      brokerimg: blackbull,
      Recommended: false,
    },
    {
      Name: "TMGM",
      lose: '74-89',
      Country: ['AllCountry',
        'Afghanistan', 'Albania', "Israel", 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda',
        'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Bahrain', 'Bangladesh', 'Belgium', 'Brazil', 'China',
        'Cyprus', 'Denmark', 'Egypt', 'Finland', 'France', 'Germany', 'Hong Kong', 'Ireland', 'Israel', 'Italy', 'Japan',
        'Kuwait', 'Luxembourg', 'Netherlands', 'New Zealand', 'Oman', 'Poland', 'Qatar', 'Singapore',
        'South Africa', 'Spain', 'Sweden', 'Switzerland', 'United Arab Emirates', 'United Kingdom'
      ],
      url: "https://www.tmgm.com",
      ratting: 4.4,
      mindeposit: "$100",
      maxLeverge: "500:1",
      platform: "MT4",
      brokerimg: tmgm,
      Recommended: false,
    },
    {
      Name: "Axi",
      lose: '83.1',
      Country: ['AllCountry',
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antigua & Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Bahrain",
        "Bangladesh",
        "Belgium",
        "Brazil",
        "China",
        "Cyprus",
        "Denmark",
        "Egypt",
        "Finland",
        "France",
        "Germany",
        "Hong Kong",
        "Ireland",
        "Israel",
        "Italy",

        "Kuwait",

        "Netherlands",
        "New Zealand",
        "Oman",
        "Poland",
        "Qatar",
        "Saudi Arabia",
        "Singapore",
        "South Africa",
        "Spain",
        "Sweden",
        "Switzerland",
        "United Arab Emirates",
        "United Kingdom"
      ],
      url: "https://www.axi.com",
      ratting: 4.3,
      mindeposit: "$0",
      maxLeverge: "500:1",
      platform: "MT4",
      brokerimg: axi,
      Recommended: false,
    },

  ];
  const [searchValue, setSearchValue] = useState("");
  const [filteredBrokers, setFilteredBrokers] = useState([]);
  // const [userData, setUserData] = useState(null);
  
  const [SelectCountry, setSelectedCountry] = useState();

  const countryCodes = {
    'AF': 'Afghanistan',
    'AE': 'United Arab Emirates',

    'AL': 'Albania',
    'DZ': 'Algeria',
    'AS': 'American Samoa',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AI': 'Anguilla',
    'AG': 'Antigua and Barbuda',
    'AR': 'Argentina',
    'AM': 'Armenia',
    'AW': 'Aruba',
    'AU': 'Australia',
    'AT': 'Austria',
    'BH': 'Bahrain',
    'BD': 'Bangladesh',
    'BE': 'Belgium',
    'BR': 'Brazil',
    'CN': 'China',
    'CY': 'Cyprus',
    'DK': 'Denmark',
    'EG': 'Egypt',
    'FI': 'Finland',
    'FR': 'France',
    'DE': 'Germany',
    'HK': 'Hong Kong',
    'IE': 'Ireland',
    'IL': 'Israel',
    'IT': 'Italy',
    'JP': 'Japan',
    'KW': 'Kuwait',
    'LU': 'Luxembourg',
    'NL': 'Netherlands',
    'NZ': 'New Zealand',
    'OM': 'Oman',
    'PL': 'Poland',
    'QA': 'Qatar',
    'SA': 'Saudi Arabia',
    'SG': 'Singapore',
    'ZA': 'South Africa',
    'ES': 'Spain',
    'SE': 'Sweden',
    'CH': 'Switzerland',
    'UAE': 'United Arab Emirates',
    'GB': 'United Kingdom',
    'PK': 'AllCountry',
    'US': 'AllCountry',
    'RU': 'AllCountry',
    'TR': 'AllCountry',
    'IN': 'AllCountry',
    'CA': 'AllCountry',
    'MX': 'AllCountry',
    'NG': 'AllCountry',
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json?token=dec4b91441eb65');
        const data = await response.json();
        const fullCountry = countryCodes[data.country];
        // console.log(countryCodes[data.country],"countryCodes[data.country]")
        // setUserData(fullCountry || data.country);
        // const condition = fullCountry ? fullCountry : "AllCountry";
        const condition = fullCountry && Object.values(countryCodes).includes(fullCountry) ? fullCountry : "AllCountry";
        setSelectedCountry(condition);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCountry = (event) => {
    setSelectedCountry(event.value);
  };

  // useEffect(() => {
  //   const condition = userData && Object.values(countryCodes).includes(userData) ? userData : "AllCountry";
  //   setSelectedCountry(condition);
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userData]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
    filterBrokers(event.target.value);
  };

  const newdata = BrokerData.filter(broker => broker.Country?.includes(SelectCountry));
  
  console.log(newdata.slice(0,3), "hellowrodl");
  console.log(filteredBrokers, "filteredBrokers");
  const filterBrokers = (searchText) => {
    const filteredResults = newdata.filter((broker) =>
      broker.Name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredBrokers(filteredResults);
  };

  const minRating = 0.1;
  const maxRating = 5.0;
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "450px",
      margin: "0 auto",
      marginTop: "10px",
      "@media (max-width: 600px)": {
        width: "320px"

      }
      ,
      "@media (min-width: 1500px)": {
        width: "520px"
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1,
      marginLeft: "335px",
      width: "450px",
      "@media (max-width: 600px)": {
        width: "320px",
        marginLeft:"10px"
      }
    })
  };

  return (
    <>

      <Header />
      {
        SelectCountry ?
      <>

      <div className="container">
        <div className="row d-flex-justify-content-center py-4">
          <div className="col-md-12">
            <h1 className="text-bold text-center main-review-head py-2">
              Broker reviews
            </h1>

            {/* <h2 className="text-bold text-center py-2">
              Find the right broker and invest on your own
            </h2> */}

            <Select
              styles={selectStyles}
              options={countries}
              defaultValue={{label:SelectCountry, value:SelectCountry}}
              onChange={handleCountry}

            />




            <div className="review-select py-2">

              <h6 className="text-bold ">Filter by name</h6>
              <input
                type="text"
                className="form-control bn"
                placeholder="Search by Name"
                value={searchValue}
                onChange={handleSearchChange}
              />
            </div>

          </div>
        </div>
      </div>
      <section className="brokerlist py-5" style={{ backgroundColor: "#ecf0f2", }}>
        <div className="container">
          <div className="row">
            <h2
              className="text-center"
              style={{ fontSize: "32px", fontWeight: "600" }}
            >
              Brokers Available For {SelectCountry}
            </h2>
            <div className="row gy-5 gx-2 " style={{marginLeft:"2px"}}>
              {filteredBrokers.length === 0 &&
                !searchValue &&
                newdata?.map((e, i) => (
                  <div
                    key={i}
                    className="col-lg-4 pricing-block style-two animated fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1200ms"
                  >
                    <div
                      className="inner-box"
                      style={
                        e?.Recommended === false
                          ? { border: "0px", paddingTop: "42px" }
                          : {}
                      }
                    >
                      <div className="lower-content">
                        {e?.Recommended && (
                          <h5>{e?.Recommended && "Recommended"}</h5>
                        )}
                        <h4 style={{ marginTop: "0px" }}>
                          <span onClick={() => window.open(e?.url, "_blank")} style={{ cursor: "pointer" }}>
                            <img
                              src={e.brokerimg}
                              width={"77"}
                              height={"77"}
                              style={{
                                borderRadious: "10px",
                                boxShadow: "5px 5px 10px rgba(0,0,0,.23)"
                              }}
                              alt=""
                              srcset=""
                              className="mb-2 rounded-2"
                            />
                          </span>
                          <br />
                          <span style={{fontSize:"15px"}}>

                          {e?.Name}
                          </span>
                        </h4>
                        <div className="d-flex py-3 gap-2 justify-content-center  align-items-center setgap flex-reverse ">
                          <h3
                            className="mt-2"
                            style={{
                              fontSize: "14px",
                            }}
                          >
                            {e?.ratting}
                          </h3>
                          <div className=" d-flex justify-content-center">
                            <div class="ratings">
                              <div class="empty-stars"></div>
                              <div
                                className="full-stars"
                                style={{
                                  width: `${((e?.ratting - minRating) /
                                    (maxRating - minRating)) *
                                    100
                                    }%`,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div
                            className={`py-2 mb-4`}
                            style={{ height: "92px" }}
                          >
                            <div className="grid grid-cols-2 text-sm">
                              <div className="text-slate-600 text-left">
                                {" "}
                                Min. Deposit:
                              </div>
                              <div className="mr-4 flex"> {e?.mindeposit}</div>
                            </div>
                            <div className="grid grid-cols-2 text-sm">
                              <div className="text-slate-600 text-left">
                                {" "}
                                Max. Leverage
                              </div>
                              <div className="mr-4 flex">{e?.maxLeverge} </div>
                            </div>
                            <div className="grid grid-cols-2 text-sm">
                              <div className="text-slate-600 text-left">
                                Trading Platform{" "}
                              </div>

                              <div className="mr-4 flex">{e?.platform}</div>
                            </div>

                          </div>
                        </div>

                        <div className="link-btn" style={{ cursor: "pointer" }}>
                          <span onClick={() => window.open(`${e?.url}`, '_blank')} className="theme-btn btn-style-two">
                            <span className="btn-title ">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px", cursor: "pointer" }} /></span>
                          </span>
                        </div>
                        <div className="hint">

                          <Link to={e?.path} className="forhover">
                            {" "}
                            <span style={{ borderBottom: "1px solid #0a2cd4" }}>
                              Read review
                            </span>{" "}
                          </Link>
                          <p className="tradepara py-1 mt-2 mb-0">
                            {e?.lose}% of retail CFD accounts lose money
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {filteredBrokers.map((e, i) => (
                <div
                  key={i}
                  className="col-lg-4 pricing-block style-two animated fadeInUp"
                  data-wow-delay="200ms"
                  data-wow-duration="1200ms"
                >
                  <div
                    className="inner-box"
                    style={
                      e?.Recommended === false
                        ? { border: "0px", paddingTop: "41px" }
                        : {}
                    }
                  >
                    <div className="lower-content">
                      {e?.Recommended && (
                        <h5>{e?.Recommended && "Recommended"}</h5>
                      )}
                      <h4 style={{ marginTop: "0px" }}>

                        <span onClick={() => window.open(`${e?.url}`, '_blank')} className='cursor-pointer' >
                          <img
                            src={e.brokerimg}
                            width={"77"}
                            height={"77"}
                            style={{
                              borderRadious: "10px",
                              boxShadow: "5px 5px 10px rgba(0,0,0,.23)"
                            }}
                            alt=""
                            srcset=""
                            className="mb-2 rounded-2"
                          />
                        </span>

                        <br />

                        {e?.Name}
                      </h4>
                      <div className="d-flex py-3 gap-2 justify-content-center  align-items-center setgap flex-reverse ">
                        <h3
                          className="mt-2"
                          style={{
                            fontSize: "14px",
                          }}
                        >
                          {e?.ratting}
                        </h3>
                        <div className=" d-flex justify-content-center">
                          <div class="ratings">
                            <div class="empty-stars"></div>
                            <div
                              className="full-stars"
                              style={{
                                width: `${((e?.ratting - minRating) /
                                  (maxRating - minRating)) *
                                  100
                                  }%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className={`py-2 mb-4`} style={{ height: "92px" }}>
                          <div className="grid grid-cols-2 text-sm">
                            <div className="text-slate-600 text-left">
                              {" "}
                              Min. Deposit:
                            </div>
                            <div className="mr-4 flex"> {e?.mindeposit}</div>
                          </div>
                          <div className="grid grid-cols-2 text-sm">
                            <div className="text-slate-600 text-left">
                              {" "}
                              Max. Leverage
                            </div>
                            <div className="mr-4 flex">{e?.maxLeverge} </div>
                          </div>
                          <div className="grid grid-cols-2 text-sm">
                            <div className="text-slate-600 text-left">
                              Trading Platform{" "}
                            </div>

                            <div className="mr-4 flex">{e?.platform}</div>
                          </div>

                        </div>
                      </div>

                      <div className="link-btn" style={{ cursor: "pointer" }}>
                        <span onClick={() => window.open(`${e?.url}`, '_blank')} className="theme-btn btn-style-two cursor-pointer"  >
                          <span className="btn-title">VISIT BROKER {" "}<LuExternalLink size='22' style={{ paddingBottom: "5px" }} /></span>
                        </span>
                      </div>
                      <div className="hint">
                        <span className="forhover  cursor-pointer">
                          {" "}
                          <Link to={e?.path} className="forhover" style={{ borderBottom: "1px solid #0a2cd4", }} >
                            Read review
                          </Link >{" "}
                        </span>
                        <p className="tradepara py-1 mt-2 mb-0">
                          {e?.lose}% of retail CFD accounts lose money
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {searchValue && filteredBrokers.length === 0 && (
                <p>We couldn`t find any brokers based on your search.</p>
              )}
            </div>
          </div>
        </div>
      </section>
      </>
      : <div className="Loader"></div>
    }


      <Footer />
    </>
  );
};

export default Allreview;
